export class SC_RoofHook
	{
		public static  TYPE_VARIO_DUO:number = 1;
		public static  TYPE_VARIO_SOLO:number = 2;
		public static  BASE_PLATE_BIG:number = 1;
		public static  BASE_PLATE_SMALL:number = 2;
		public static  BASE_PLATE_MIXED:number = 3;
	}